import LocalSettingsProto from "../../../../core/gd/settings/local-settings/local-settings-v4"

export default class NavigationMenu_ReportsLocalSettings extends LocalSettingsProto {

    private _allReportsExpanded: boolean = false

    constructor() {
        super('menu-reports-' + gd.companyId)

        const values = this._readFromLocalStorage()
        this._allReportsExpanded = _.get(values, 'allReportsExpanded', false)
    }

    get allReportsExpanded() {
        return this._allReportsExpanded
    }

    set allReportsExpanded(value: boolean) {
        this._allReportsExpanded = value
        this.save()
    }

    toObject() {
        return {
            allReportsExpanded: this._allReportsExpanded,
        }
    }
}
